<template>
  <v-list-tile>
    <v-list-tile avatar @click="selectCell" class="restarant-cell">
      <v-list-tile-avatar>
        <v-icon>restaurant</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title>{{ restaurant.nm }}</v-list-tile-title>
        <!-- <v-list-item-subtitle>사용자 : {{ restaurant.user_cnt }}명</v-list-item-subtitle> -->
      </v-list-tile-content>

      <v-list-tile-action @click="setting">
        <v-btn icon ripple>
          <v-icon color="grey lighten-1">settings</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
    <v-dialog v-model="settingDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <restaurant-setting-modal :restaurant="restaurant" :settingDialog.sync="settingDialog"></restaurant-setting-modal>
    </v-dialog>
  </v-list-tile>
</template>

<script>
import RestaurantSettingModal from "@/components/RestaurantSettingModal";
export default {
  name: "RestaurantCell",
  props: {
    restaurant: {
      type: Object
    }
  },
  data: () => ({
    settingDialog: false
  }),
  components: {
    RestaurantSettingModal
  },
  methods: {
    selectCell: function() {
      this.$store.commit("setRestaurant", this.restaurant);
    },
    setting: function() {
      //
      // alert("setting");
      this.settingDialog = true;
    }
  }
};
</script>

<style scoped>
.restarant-cell {
  width: 280px;
}
</style>